export const apiConstants = {
  ingredients: '/ingredients',
  category: '/ingredient/categories',
};
